/*
* 获取微信sdk签名
* */
import api from 'api/user';
import wx from 'weixin-js-sdk';
async function getWxSign(cb) {
  const data = await api.getSign({
    url:window.location.href
  })
  wx.config({
    debug: false, // 开启调
    // 试模式,
    appId: data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
    timestamp: data.timestamp, // 必填，生成签名的时间戳
    nonceStr: data.noncestr, // 必填，生成签名的随机串
    signature: data.signature,// 必填，签名，见附录1
    jsApiList: ['onMenuShareAppMessage','onMenuShareTimeline','chooseWXPay','openAddress'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
  });
  cb && wx.ready(cb)
}

export {
  getWxSign
}
